import type { PortableTextBlock, PortableTextMarkComponent } from "next-sanity";
import { ActionLink } from "@/components/common/actions/actions.component";
type LinkValue = {
  _type: "link";
  to?: Parameters<typeof ActionLink>[0]["actionTo"];
};
export const linkMarkHandler: PortableTextMarkComponent<LinkValue> = ({
  children,
  value
}) => <ActionLink className="hover:underline" actionTo={value?.to}>
    {children}
  </ActionLink>;
type HrefLinkValue = {
  _type: "link";
  href?: string;
};
export const hrefLinkMarkHandler: PortableTextMarkComponent<HrefLinkValue> = ({
  children,
  value
}) => {
  if (!value?.href) return <>{children}</>;
  return <a href={value.href} className="underline hover:no-underline" target="_blank" rel="noopener noreferrer">
      {children}
    </a>;
};
export const hardBreakHandler = () => <br />;

/**
 * Tailwind Typography (`prose`) base applied to every rich-text component.
 * Strips prose's default colour so wrapper typography / colour classes win,
 * lifts the max-width cap, and adds scroll-margin for in-page heading anchors.
 *
 * Bold (`<strong>`) maps to SemiBold (600) — the system's emphasis weight
 * (all H2–H5/overline tokens, and the heaviest loaded Yellix cut; no 700
 * face exists) — and promotes to text-primary. Medium (500) was too subtle
 * against 400 body copy and invisible inside body-*-medium contexts
 * (VAW-1731).
 */
export const proseBaseClasses = "prose prose-headings:scroll-m-24 max-w-none text-inherit prose-a:text-inherit prose-table:m-0 prose-strong:font-semibold prose-strong:text-text-primary";
export function asPortableText(value: unknown): PortableTextBlock[] {
  return value as PortableTextBlock[];
}
export const onMissingPortableTextComponent = (_: unknown, {
  nodeType,
  type
}: {
  nodeType: string;
  type: string;
}): void => {
  if (process.env.NODE_ENV !== "production") {
    console.warn("[PortableText] missing component", nodeType, type);
  }
};